import React from "react";
import { Slider, Box } from "@mui/material";

type Props = {
  value: [number, number];
  onChange: (min: number, max: number) => void;
  onCommit: () => void;
  min?: number;
  max?: number;
};

const PriceSlider: React.FC<Props> = ({
                                        value,
                                        onChange,
                                        onCommit,
                                        min = 0,
                                        max = 100000
                                      }) => (
    <Box>
      <Slider
          value={value}
          min={min}
          max={max}
          step={1}
          disableSwap
          onChange={(_, v) => Array.isArray(v) && onChange(v[0], v[1])}
          onChangeCommitted={onCommit}
          valueLabelDisplay="auto"
          sx={{
            paddingY: 1.5,
            "& .MuiSlider-track": {
              height: 6,
              borderRadius: 9999,
              background: "linear-gradient(to right,#1d4ed8,#3b82f6)",
            },
            "& .MuiSlider-rail": {
              height: 6,
              borderRadius: 9999,
              opacity: 0.4,
              background: "#1e3a8a",
            },
            "& .MuiSlider-thumb": {
              width: 16,
              height: 16,
              backgroundColor: "#f0f9ff",
              border: "1px solid #1e40af",
              borderRadius: "9999px",
            },
          }}
      />
    </Box>
);

export default PriceSlider;